module.exports = __webpack_public_path__ + "static/media/netlify-logo.bf3efff2.png";